import { VrLessonProgress } from "models/LessonProgress";
import { Node } from "models/Node";
import { LessonProgressNodes } from "components/views/myTrainings/LessonProgressNodes/LessonProgressNodes";

export const VrLessonProgressSection = (props: { lp: VrLessonProgress; isCompleted: boolean; nodes: Node[]; gettingNodes: boolean }) => {
    const { lp, isCompleted, nodes, gettingNodes } = props;

    return (
        <LessonProgressNodes
            nodes={nodes}
            gettingNodes={gettingNodes}
            completedNodes={lp.completedNodes}
            isCompleted={isCompleted}
        />
    );
};
